import {
    ADMINS_REQUESTED,
    ADMINS_SUCCEEDED,
    ADMINS_FAILED,
    DELETE_ADMINS_SUCCEEDED,
    DELETE_ADMINS_REQUESTED,
    DELETE_ADMINS_FAILED,
    ADD_ADMINS_REQUESTED,
    ADD_ADMINS_SUCCEEDED,
    ADD_ADMINS_FAILED,
    CITIZEN_SCIENTIST_REQUESTED,
    CITIZEN_SCIENTIST_SUCCEEDED,
    CITIZEN_SCIENTIST_FAILED,
    ADD_CITIZEN_SCIENTIST_REQUESTED,
    ADD_CITIZEN_SCIENTIST_SUCCEEDED,
    ADD_CITIZEN_SCIENTIST_FAILED,
    DELETE_CITIZEN_SCIENTIST_REQUESTED,
    DELETE_CITIZEN_SCIENTIST_SUCCEEDED,
    DELETE_CITIZEN_SCIENTIST_FAILED,
    CHILD_PARTNER_FAILED,
    ADD_CHILD_ADMIN_REQUESTED,
    ADD_CHILD_ADMIN_SUCCEEDED,
    ADD_CHILD_ADMIN_FAILED,
    CHILD_INSIRE_CAMPUS_PARTNER_SUCCEEDED,
    CHILD_INSPIRE_CAMPUS_PARTNER_FAILED,
    CHILD_INSPIRE_PARTNER_SUCCEEDED,
    CHILD_INSPIRE_PARTNER_FAILED,
    CHILD_INSPIRE_PARTNER_REQUESTED,
    CHILD_INSPIRE_CAMPUS_PARTNER_REQUESTED,
    REMOVE_CHILD_ADMIN_REQUESTED,
    REMOVE_CHILD_ADMIN_SUCCEEDED,
    REMOVE_CHILD_ADMIN_FAILED,
    CREATE_PARTNER_REQUESTED,
    CREATE_PARTNER_SUCCEEDED,
    CREATE_PARTNER_FAILED,
    CLEAR_ERROR_STATE,
    DELETE_INVITE_REQUESTED,
    DELETE_INVITE_SUCCEEDED,
    DELETE_INVITE_FAILED,
    USERS_FAILED,
    USERS_SUCCEEDED,
    USERS_REQUESTED,
    ADD_USERS_REQUESTED,
    ADD_USERS_SUCCEEDED,
    ADD_USERS_FAILED,
    REMOVE_USER_REQUESTED,
    REMOVE_USER_SUCCEEDED,
    REMOVE_USER_FAILED,
} from './constants';

const initialState = {
    admins: null,
    adminsLoading: false,
    error: null,

    adminError: null,

    deletedAdmin: null,

    deleteAdminError: null,

    addAdmin: null,

    addAdminMessage: null,

    addAdminError: null,

    scientist: null,

    loadingScientist: false,
    scientistError: null,

    addScientist: null,

    scientistAddMessage: null,

    scientistAddError: null,

    deleteScientist: null,

    deleteScientistMessage: null,

    deleteScientistError: null,

    partnerTypeKey: null,

    childInspirePartners: null,
    loadingChildInspirePartners: false,

    childCampusPartners: null,
    loadingChildCampusPartners: false,
    childPartnerError: null,

    childId: null,

    childEmail: null,

    InspireAdminMessage: null,

    InspireAdminErrorId: null,

    InspireAdminError: null,

    removeChildAdminErrorId: null,

    removeChildAdminError: null,

    partnerDetails: null,

    createPartnerMessage: null,

    createPartnerError: null,

    errorPartnerType: null,

    addAdminRequested: false,

    addScientistRequested: false,

    addChildAdminRequested: false,

    addChildAdminRequestedId: null,

    createScientistRequested: false,

    createPartnerRequested: false,

    deleteUserRequested: false,

    updateChildPartnerInProgress: false,

    childType: null,

    usersError: null,
    users: null,
    usersLoading: false,
    userAdding: false,
    userAddError: null,
    userRemoving: false,
    userRemovingError: null,
};

export default function(state = initialState, action) {
    switch (action.type) {
        case REMOVE_USER_REQUESTED: {
            return {
                ...state,
                userAddError: null,
                userRemovingError: null,
                userRemoving: true,
            };
        }
        case REMOVE_USER_SUCCEEDED: {
            return {
                ...state,
                userRemoving: false,
            };
        }
        case REMOVE_USER_FAILED: {
            const { error } = action;
            return {
                ...state,
                userRemovingError: error,
                userRemoving: false,
            };
        }
        case ADD_USERS_REQUESTED: {
            return {
                ...state,
                userAddError: null,
                userRemovingError: null,
                userAdding: true,
            };
        }
        case ADD_USERS_SUCCEEDED: {
            return {
                ...state,
                userAdding: false,
            };
        }
        case ADD_USERS_FAILED: {
            const { error } = action;
            return {
                ...state,
                userAddError: error,
                userAdding: false,
            };
        }
        case USERS_REQUESTED: {
            return {
                ...state,
                usersError: null,
                usersLoading: true,
            };
        }
        case USERS_SUCCEEDED: {
            const { users } = action;
            return {
                ...state,
                users,
                usersLoading: false,
            };
        }
        case USERS_FAILED: {
            const { error } = action;
            return {
                ...state,
                usersError: error,
                usersLoading: false,
            };
        }
        case ADMINS_REQUESTED: {
            return {
                ...state,
                adminError: null,
                adminsLoading: true,
            };
        }
        case ADMINS_SUCCEEDED: {
            const { admins } = action;
            return {
                ...state,
                admins,
                adminsLoading: false,
            };
        }
        case ADMINS_FAILED: {
            const { error } = action;
            return {
                ...state,
                adminError: error,
                adminsLoading: false,
            };
        }
        case DELETE_ADMINS_REQUESTED: {
            const { id } = action;
            return {
                ...state,
                deletedAdmin: id,
                deleteAdminError: null,

                deleteUserRequested: true,
            };
        }
        case DELETE_ADMINS_SUCCEEDED: {
            return {
                ...state,

                deleteUserRequested: false,
            };
        }
        case DELETE_ADMINS_FAILED: {
            const { error } = action;
            return {
                ...state,
                deleteAdminError: error,

                deleteUserRequested: false,
            };
        }
        case DELETE_INVITE_REQUESTED: {
            return {
                ...state,
                deleteUserRequested: true,
            };
        }
        case DELETE_INVITE_SUCCEEDED: {
            return {
                ...state,
                deleteUserRequested: false,
            };
        }
        case DELETE_INVITE_FAILED: {
            const { error } = action;
            return {
                ...state,
                deleteInviteError: error,
                deleteUserRequested: false,
            };
        }
        case ADD_ADMINS_REQUESTED: {
            const { email } = action;
            return {
                ...state,
                addAdmin: email,
                addAdminError: null,

                addAdminRequested: true,
            };
        }
        case ADD_ADMINS_SUCCEEDED: {
            const { message } = action;
            return {
                ...state,
                addAdminMessage: message,

                addAdminRequested: false,
            };
        }
        case ADD_ADMINS_FAILED: {
            const { error } = action;
            return {
                ...state,
                addAdminError: error,

                addAdminRequested: false,
            };
        }
        case CITIZEN_SCIENTIST_REQUESTED: {
            return {
                ...state,
                scientistError: null,
                loadingScientist: true,
            };
        }
        case CITIZEN_SCIENTIST_SUCCEEDED: {
            const { scientist } = action;
            return {
                ...state,
                scientist,
                loadingScientist: false,
            };
        }
        case CITIZEN_SCIENTIST_FAILED: {
            const { scientistError } = action;
            return {
                ...state,
                scientistError,
                loadingScientist: false,
            };
        }
        case ADD_CITIZEN_SCIENTIST_REQUESTED: {
            const { email } = action;
            return {
                ...state,
                addScientist: email,
                scientistAddError: null,

                addScientistRequested: true,
            };
        }
        case ADD_CITIZEN_SCIENTIST_SUCCEEDED: {
            const { message } = action;
            return {
                ...state,
                scientistAddMessage: message,

                addScientistRequested: false,
            };
        }
        case ADD_CITIZEN_SCIENTIST_FAILED: {
            const { error } = action;
            return {
                ...state,
                scientistAddError: error,

                addScientistRequested: false,
            };
        }
        case DELETE_CITIZEN_SCIENTIST_REQUESTED: {
            const { id } = action;
            return {
                ...state,
                deletedScientist: id,
                deleteScientistError: null,

                deleteUserRequested: true,
            };
        }
        case DELETE_CITIZEN_SCIENTIST_SUCCEEDED: {
            const { message } = action;
            return {
                ...state,
                deleteScientistMessage: message,

                deleteUserRequested: false,
            };
        }
        case DELETE_CITIZEN_SCIENTIST_FAILED: {
            const { error } = action;
            return {
                ...state,
                deleteScientistError: error,

                deleteUserRequested: false,
            };
        }
        case CHILD_INSPIRE_PARTNER_REQUESTED: {
            return {
                ...state,
                childPartnerError: null,
                loadingChildInspirePartners: true,
                updateChildPartnerInProgress: true,
            };
        }
        case CHILD_INSPIRE_CAMPUS_PARTNER_REQUESTED: {
            return {
                ...state,
                childPartnerError: null,
                loadingChildCampusPartners: true,
                updateChildPartnerInProgress: true,
            };
        }
        case CHILD_INSPIRE_PARTNER_SUCCEEDED: {
            const { inspire } = action;
            return {
                ...state,
                childInspirePartners: inspire,
                loadingChildInspirePartners: false,
                updateChildPartnerInProgress: false,
            };
        }
        case CHILD_INSPIRE_PARTNER_FAILED: {
            const { error } = action;
            return {
                ...state,
                loadingChildInspirePartners: false,
                error,
            };
        }
        case CHILD_INSIRE_CAMPUS_PARTNER_SUCCEEDED: {
            const { campus } = action;
            return {
                ...state,
                childCampusPartners: campus,
                loadingChildCampusPartners: false,
                updateChildPartnerInProgress: false,
            };
        }
        case CHILD_INSPIRE_CAMPUS_PARTNER_FAILED: {
            const { error } = action;
            return {
                ...state,
                loadingChildCampusPartners: false,
                error,
            };
        }
        case CHILD_PARTNER_FAILED: {
            const { error } = action;
            return {
                ...state,
                childPartnerError: error,

                updateChildPartnerInProgress: false,
            };
        }
        case ADD_CHILD_ADMIN_REQUESTED: {
            const { childId, email, childType } = action;
            return {
                ...state,
                childId,
                childEmail: email,

                InspireAdminErrorId: null,
                InspireAdminError: null,

                addChildAdminRequested: true,
                addChildAdminRequestedId: childId,

                updateChildPartnerInProgress: true,

                childType,
            };
        }
        case ADD_CHILD_ADMIN_SUCCEEDED: {
            const { message } = action;
            return {
                ...state,
                InspireAdminMessage: message,

                addChildAdminRequested: false,
                addChildAdminRequestedId: null,
            };
        }
        case ADD_CHILD_ADMIN_FAILED: {
            const { id, error } = action;
            return {
                ...state,
                InspireAdminErrorId: id,
                InspireAdminError: error,

                addChildAdminRequested: false,
                addChildAdminRequestedId: null,
            };
        }
        case REMOVE_CHILD_ADMIN_REQUESTED: {
            const { childId, userId, childType } = action;
            return {
                ...state,
                removeChildId: childId,
                removeChildAdminId: userId,

                removeChildAdminErrorId: null,
                removeChildAdminError: null,

                deleteUserRequested: true,

                updateChildPartnerInProgress: true,

                childType,
            };
        }
        case REMOVE_CHILD_ADMIN_SUCCEEDED: {
            const { message } = action;
            return {
                ...state,
                removeChildAdminMessage: message,

                deleteUserRequested: false,
            };
        }
        case REMOVE_CHILD_ADMIN_FAILED: {
            const { id, error } = action;
            return {
                ...state,
                removeChildAdminErrorId: id,
                removeChildAdminError: error,

                deleteUserRequested: false,
            };
        }
        case CREATE_PARTNER_REQUESTED: {
            const { partnerDetails } = action;
            return {
                ...state,
                partnerDetails,

                createPartnerError: null,
                errorPartnerType: null,

                createPartnerRequested: true,
            };
        }
        case CREATE_PARTNER_SUCCEEDED: {
            const { message } = action;
            return {
                ...state,
                createPartnerMessage: message,

                createPartnerRequested: false,
            };
        }
        case CREATE_PARTNER_FAILED: {
            const { error, errorPartnerType } = action;
            return {
                ...state,
                createPartnerError: error,
                errorPartnerType,

                createPartnerRequested: false,
            };
        }
        case CLEAR_ERROR_STATE: {
            return {
                ...state,
                adminError: null,
                deleteAdminError: null,
                addAdminError: null,
                scientistAddMessage: null,
                addAdminMessage: null,
                scientistError: null,
                scientistAddError: null,
                deleteScientistError: null,
                childPartnerError: null,
                InspireAdminErrorId: null,
                InspireAdminError: null,
                createPartnerError: null,
                errorPartnerType: null,
                removeChildAdminError: null,
                removeChildAdminErrorId: null,
            };
        }
        default:
            return state;
    }
}
